import { render, staticRenderFns } from "./DateTemplate.vue?vue&type=template&id=08ac06ca&scoped=true&"
import script from "./DateTemplate.vue?vue&type=script&lang=js&"
export * from "./DateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac06ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ac06ca')) {
      api.createRecord('08ac06ca', component.options)
    } else {
      api.reload('08ac06ca', component.options)
    }
    module.hot.accept("./DateTemplate.vue?vue&type=template&id=08ac06ca&scoped=true&", function () {
      api.rerender('08ac06ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/DateTemplate.vue"
export default component.exports